"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constant = require("../Theme/constant");
var _default = {
  PropTypes: {
    theme: _propTypes.default.string,
    accessible: _propTypes.default.bool,
    customProperties: _propTypes.default.object,
    translation: _propTypes.default.object,
    isMobile: _propTypes.default.bool,
    ssrType: _propTypes.default.string,
    handleTabSelection: _propTypes.default.func,
    selectedTab: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
    tabList: _propTypes.default.arrayOf(_propTypes.default.shape({
      id: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
      label: _propTypes.default.string,
      icon: _propTypes.default.string
    })),
    departStation: _propTypes.default.string,
    arrivalStation: _propTypes.default.string,
    hideTileHeader: _propTypes.default.bool
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    accessible: true,
    customProperties: {},
    translation: {},
    isMobile: false,
    ssrType: null,
    handleTabSelection: function handleTabSelection() {},
    selectedTab: null,
    tabList: [],
    departStation: '',
    arrivalStation: '',
    hideTileHeader: false
  }
};
exports.default = _default;